import React from 'react';
import { observer } from 'mobx-react-lite';
import { userSettingsStore } from '@pascal/pascal-core';
import { kenoBetStore } from '../../../../store/kenoBetStore';
import { soundService } from '../../../../services/baseSoundService';
import useTranslation from '../../../../hooks/useTranslation';
import { TranslationKeys } from '../../../../core/constants/translationKeys';

const ClearTicket = observer(() => {
  const { selectedNumbers, setSelectedNumbers } = kenoBetStore;
  const { isSoundOn } = userSettingsStore;
  const t = useTranslation();
  return (
    <div className='keno-tickets-delete-btn'>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        type='button'
        data-title={t(TranslationKeys.Delete)}
        className={`delete-btn icon-delete ${selectedNumbers.length ? '' : 'disabled'}`}
        onClick={() => {
          if (isSoundOn) {
            soundService.playClearDelete();
          }
          setSelectedNumbers([]);
        }}
      >
        <span className='btn-txt-label' />
      </button>
    </div>
  );
});
export default ClearTicket;
